import * as React from 'react';
import { Typography } from '../Typography';
import useStyles from './CssBaseline.styles';

const CssBaseline: React.FC<React.PropsWithChildren> = ({ children }) => {
  const classes = useStyles();
  return (
    <Typography tag="div" className={classes.root}>
      {children}
    </Typography>
  );
};

export default CssBaseline;
